export default class Price {
  /**
   * Formate un prix exprime en centimes selon la locale de l'order page.
   *
   * - `lang` est lu depuis `window.globalConfig.lang` (fallback `fr-FR`).
   *   En FR le separateur decimal est `,` et les milliers sont separes par
   *   un espace insecable (ex: `1 234,56`). En EN c'est `1,234.56`.
   * - Le symbole de devise n'est PAS inclus : il est rendu separement par
   *   les composants Vue (`<span class="currency">€</span>`) pour permettre
   *   un controle de typographie precis (espacement, font-weight).
   * - `hidePriceDecimals` (config admin) force l'affichage sans decimales.
   *
   * Migration depuis l'ancien format `1 234.56` (separateur de milliers FR
   * + point decimal US, non standard) vers un format conforme aux
   * conventions ISO de la locale. Voir tests/unit/services/price.test.js.
   */
  static format(price) {
    const priceWithDecimal = price / 100;
    const decimals = window.globalConfig?.hidePriceDecimals ? 0 : 2;
    const lang = window.globalConfig?.lang || "fr";
    const locale =
      lang.indexOf("-") === -1 ? lang + "-" + lang.toUpperCase() : lang;
    try {
      return new Intl.NumberFormat(locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
        useGrouping: true,
      }).format(priceWithDecimal);
    } catch (e) {
      // Fallback minimal si Intl.NumberFormat indisponible ou locale
      // invalide (cas tres rare, IE11 et anciennes runtimes JS).
      return priceWithDecimal
        .toFixed(decimals)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1\u00A0")
        .replace(".", ",");
    }
  }
}
